export const styles = {
  shuffleAttendeesCountdownCtn: { left: { xs: 0, md: "auto" } },
  dialogTitle: {
    justifyContent: "flex-end",
    p: 0,
    display: { xs: "none", md: "flex" },
  },
  closeButton: {
    borderRadius: 5,
    marginTop: 0,
    marginRight: 0,
    float: "right",
  },
  content: {
    display: "flex",
    maxWidth: "375px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    overflowY: "auto",
    p: { xs: 2, md: 4 },
    gap: 2,
  },
  image: {
    width: { xs: "calc(100% - 32px)", md: "calc(100% - 75px)" },
  },
  icon: {
    height: 28,
    width: 28,
  },
  minimizeShufflingBtn: {
    display: { xs: "block", md: "none" },
  },
  closeIcon: {
    color: "icon.secondary",
  },
};
